// eslint-disable-next-line import/prefer-default-export
export const getItem = (state, itemUID) => state.items.data[itemUID];
